import { FC } from "react";
import Chart from "react-chartjs-2";
import useTimelinePage from "./useTimeline";
import Skeleton from "components/atom/Skeleton";

const Timeline: FC = () => {
  const {
    chartTimeLineProps,
    isLoading,
    categoriesJP,
    activeCategoryIdx,
    onCategoryChange,
    interval,
    onIntervalChange,
  } = useTimelinePage();

  return (
    <>
      <h2 className="subtitle">
        時系列グラフ
        <p className="my-1 is-size-6">
          このグラフではお店がより良くなっているか確認することが出来ます。
        </p>
      </h2>
      <form>
        <div className="field is-flex is-flex-wrap-wrap">
          {/* <div className="control mx-2">
            <label className="label">開始</label>
            <div className="select is-small">
              <DatePicker
                selected={startAt}
                onChange={(date: Date) => setStartAt(date)}
                locale="ja"
                className="input is-small"
                dateFormat="yyyy/MM/dd"
              />
            </div>
          </div> */}

          <div className="control mx-2">
            <label className="label">表示範囲</label>
            <div className="select is-small">
              <select value={interval} onChange={onIntervalChange}>
                <option value="day">30日</option>
                <option value="week">8週間</option>
                <option value="month">12ヶ月</option>
                <option value="year">5年間</option>
              </select>
            </div>
          </div>
          <div className="control mx-2">
            <label className="label">カテゴリ</label>
            <div className="select is-small">
              <select onChange={onCategoryChange} value={activeCategoryIdx}>
                {/* FIXME multi select */}
                {categoriesJP.map((c, i) => (
                  <option key={c} value={i}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </form>

      {isLoading ? (
        <Skeleton height={300} />
      ) : (
        chartTimeLineProps && (
          <div
            className="my-4"
            style={{
              position: "relative",
              height: "50vh",
              // width: "85vw",
              marginLeft: "-1.5rem",
            }}
          >
            <Chart {...chartTimeLineProps} />
          </div>
        )
      )}
    </>
  );
};

export default Timeline;
